import { useHandleNavigate } from "../../../utils/utils";
import { Dialog } from "../core/modal.core";

type AppProps = {
  children: React.ReactNode;
  navigatePath: string;
};
export const Modal: React.FunctionComponent<AppProps> = ({
  navigatePath,
  children,
}) => {
  const { handleNavigate, open } = useHandleNavigate(navigatePath);

  return (
    <Dialog defaultOpen={open} onOpenChange={handleNavigate}>
      {children}
    </Dialog>
  );
};
